// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"333":"05a7eec0","640":"80a4aaa8"}[chunkId] + ".js";
};